import { AbstractControl, FormGroup } from '@angular/forms';

import { ModalService } from '../../../shared/modal';
import { MilaMultiSelectFetcher } from '../../../shared/mila-multi-select/mila-multi-select-option.model';
import { MilaMultiSelectSheet } from '../../../shared/mila-multi-select/mila-multi-select-sheet/mila-multi-select-sheet';

/** Phone version of one "Filter cikisi content by" row: opens its picker as
 *  a bottom sheet and writes the result back. The row is on exactly when
 *  something is picked (the phone flow has no separate on/off; see the
 *  rows' onFilterRowHeaderClick). */
export function openCikisiFilterSheet(
  modalService: ModalService,
  meta: { label: string; placeholder: string },
  fetchPage: MilaMultiSelectFetcher,
  rowCtrl: AbstractControl,
): void {
  const row = rowCtrl as FormGroup;
  const chips = row.get('chips')!;
  modalService.medium(MilaMultiSelectSheet, {
    data: { title: meta.label, placeholder: meta.placeholder, fetchPage, selected: chips.value ?? [] },
    // Land on the list, not the search box, so the keyboard doesn't cover it.
    autoFocus: 'dialog',
  }).closed$.subscribe(result => {
    if (!result) return;
    chips.setValue(result);
    row.get('expanded')!.setValue(result.length > 0);
  });
}
